/**
*	@author Michael
*	@since  28/03/2019
**/

export class ParametrizarParametrosModel{

    constructor(
        public nunidadesuvt:number,
        public nvaloruvt:number,
        public nanno: number
    ){}



}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ParametrizarParametros/ParametrizarParametros.model.ts